/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-classes-per-file */
import httpStatusCode from "http-status-codes";

export const URL_EXPIRED = "UrlExpired";
export const PULL_REGISTRATION_TOKEN_GONE = "PullRegistrationTokenGone";
export const SCOPE_TOKEN_EXPIRED = "ScopeTokenExpired";
export const SCOPE_TOKEN_ALREADY_USED = "ScopeTokenAlreadyUsed";
export const TIME_ERROR = "TimeError";
export const TIMEOUT = "Timeout";
export const NO_CONNECTION = "NoConnection";
export const FORBIDDEN = "Forbidden";

export const supportedErrorCodes = [
    FORBIDDEN,
    NO_CONNECTION,
    "NoDataAvailable",
    PULL_REGISTRATION_TOKEN_GONE,
    URL_EXPIRED,
    TIMEOUT,
];

export type SupportedErrorCode = (typeof supportedErrorCodes)[number];

export const isSupportedErrorCode = (errorCode?: string): boolean => {
    return errorCode && supportedErrorCodes.indexOf(errorCode) !== -1;
};

export class NetworkError extends Error {
    constructor(message?: string) {
        super(message || `No connection with the server`);
        this.name = NetworkError.name;
    }
}

export class TimeoutError extends NetworkError {
    constructor(message?: string) {
        super(message || `Connection timeout`);
        this.name = TimeoutError.name;
    }
}

export class RequestError extends Error {
    status: number | string;
    code: string;
    moreInfo: string;

    constructor(status: number | string, errorPayload: any) {
        super(errorPayload?.message ? `${errorPayload.message} [${status}]` : `Request Failed [${status}]`);
        this.status = status;
        this.name = RequestError.name;
        this.code = errorPayload?.code;
        this.moreInfo = errorPayload?.moreInfo;
    }
}

export class ForbiddenError extends RequestError {
    constructor(errorPayload: any) {
        super(httpStatusCode.FORBIDDEN, errorPayload);
        this.name = ForbiddenError.name;
    }
}

export class UnauthorizedError extends RequestError {
    constructor(errorPayload: any) {
        super(httpStatusCode.UNAUTHORIZED, errorPayload);
        this.name = UnauthorizedError.name;
    }
}

export class GoneError extends RequestError {
    constructor(errorPayload: any) {
        super(httpStatusCode.GONE, errorPayload);
        this.name = GoneError.name;
    }
}

export class NotFoundError extends RequestError {
    constructor(errorPayload: any) {
        super(httpStatusCode.NOT_FOUND, errorPayload);
        this.name = NotFoundError.name;
    }
}

export class UserExcludedError extends Error {
    constructor() {
        super("UserExcluded");
        this.name = UserExcludedError.name;
    }
}

export class TimeError extends RequestError {
    constructor(errorPayload: any) {
        super(TIME_ERROR, errorPayload);
        this.name = TimeError.name;
    }
}

export class TokenExpiredError extends UnauthorizedError {
    constructor() {
        super("TokenExpired");
        this.name = TokenExpiredError.name;
        this.message = "Token expired";
    }
}
